import { Chip, MenuItem, Select } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SelectInputs from "../../constants/SelectInputs";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import {
  createSpecialPages,
  deleteSpecialPagesData,
  getAgencies,
  getLocationByAgency,
  getLocationSpecialPageData,
  getSeawareAgencies,
  getSpecialPageLocation,
  getSpecialPagePackages,
  getVessels,
  getAllLocation,
  cleanupSpecialPageImages,
} from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import RatePlanInput from "./Components/RatePlanInput";
import SwitchBar from "./SwitchBar";

import moment from "moment-timezone";
import PropTypes from "prop-types";
import { constants } from "../../constants/constants";
import { getTimeData } from "../../constants/getTimeDate";
import { IMAGE_SUB_TYPE, IMAGE_TYPE } from "../../constants/ImageConstant";
import PortInputs from "../../constants/PortInput";
import { addlog } from "../../utils/ApiCalls/Logs";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import { uploadData } from "../../utils/ApiCalls/Upload";
import UploadFileImageBanner2 from "../Banner/uploadFileImageBanner copy";
import DateAndTimePicker from "../DateAndTimePicker";
import FareCodeList from "./FareCodeList";
import SelectInputs1 from "../../constants/SelectInputs1";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const SPECIAL_PAGE_ALT_FIELDS = [
  "image_alt",
  "simplified_chinese_image_alt",
  "traditional_chinese_image_alt",
  "bahasa_image_alt",
];

const SpecialPagesInputs = ({ page, iteneries, agencyMargetCodes }) => {
  const [englishTitle, setEnglishTitle] = useState("");
  const [locations, setLocation] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllAgencies, setSelectAllAgencies] = useState(false);
  const [slug, setSlug] = useState("");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState("");
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState("");
  const [englishdescription, setEnglishDescription] = useState("");
  const [includecode, setIncludeCode] = useState(false);
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");
  const [traditionalChineseDescripton, setTraditionalChineseDescripton] =
    useState("");
  const [bahasaTitle, setBahasaTitle] = useState("");
  const [bahasaDescription, setBahasaDescription] = useState("");
  const [bahasaFile, setBahasaFile] = useState(null);

  const [isActive, setIsActive] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseFile, setTraditionalChineseFile] = useState(null);
  const [simplifiedChineseFile, setSimplifiedChineseFile] = useState(null);
  const [url, setUrl] = useState("");
  const [altText, setAltText] = useState({});
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [activeTab, setActiveTab] = useState("page-setup");

  const [from_date, setFormDate] = useState();
  const [to_date, setToDate] = useState();
  const [valid_from, setValidFrom] = useState("");
  const [valid_to, setValidTo] = useState("");
  const [ports, setPorts] = useState({});
  const [agencyOptions, setAgencyOptions] = useState([]);
  const [displayAgency, setDisplayAgency] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [cruiseType, setCruiseTypeOptions] = useState("agencyCode");
  const [agencyMarketOptions, setAgencyMarketOptions] = useState([]);
  const [displayLocation, setDisplayLocation] = useState([]);
  const [locationOption, setLocationOption] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [isDateEdit, setIsDateEdit] = useState(false);
  const originalValidDates = useRef({ valid_from: "", valid_to: "" });
  const [agency, setAgency] = useState("");
  const [vessel, setVessel] = useState("");
  const [port, setport] = useState([]);
  const [agencyMarketCode, setAgencyMarketCode] = useState("");
  const [itineraries, setItineraries] = useState([]);
  const [selectedOption, setSelectedOption] = useState("specificRatePlans");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeyWords, setMetaKeyWords] = useState("");
  const [scMetaTitle, setScMetaTitle] = useState("");
  const [tcMetaTitle, setTcMetaTitle] = useState("");
  const [bahasaMetaTitle, setBahasaMetaTitle] = useState("");
  const [scMetaDescription, setScMetaDescription] = useState("");
  const [tcMetaDescription, setTcMetaDescription] = useState("");
  const [bahasaMetaDescription, setBahasaMetaDescription] = useState("");
  const [currentLocation, setCurrentLocation] = useState([]);

  const navigate = useNavigate();
  const cruiseTypeOptions = [
    { fields: "agencyCode", name: "Itravel" },
    { fields: "seawareAgencyCode", name: "Seaware" },
  ];

  useEffect(() => {
    if (!page?.id) {
      setIsDateEdit(true);
    }
    if (page) {
      if (page?.selected_type === "promoindexPlans") {
        setCruiseTypeOptions("seawareAgencyCode");
      }
      const timer = setTimeout(() => {
        getLocationData();
      }, 500);      
      if (page?.english_display_title) {
        let value = page.english_display_title.split("-");
        if (value && value.length > 1)
          setEnglishTitle(value.slice(0, value.length - 1).join("-"));
        else setEnglishTitle(value.join(""));
      } else {
        setEnglishTitle(page.english_display_title);
      }
      if (
        page.url
          ?.replaceAll(`${constants.PRODUCTION_URL}/special-pages/`, "")
          .includes("-")
      ) {
        setIncludeCode(true);
      }

      if (page?.simple_chinese_display_title) {
        let value = page.simple_chinese_display_title.split("-");
        if (value && value.length > 1)
          setSimplifiedChineseTitle(value.slice(0, value.length - 1).join("-"));
        else setSimplifiedChineseTitle(value.join(""));
      } else {
        setSimplifiedChineseTitle(page.simple_chinese_display_title);
      }

      if (page?.traditional_chinese_display_title) {
        let value = page.traditional_chinese_display_title.split("-");
        if (value && value.length > 1)
          setTraditionalChineseTitle(
            value.slice(0, value.length - 1).join("-")
          );
        else setTraditionalChineseTitle(value.join(""));
      } else {
        setTraditionalChineseTitle(page.traditional_chinese_display_title);
      }
      setEnglishDescription(page?.english_description);
      setSimplifiedChineseDescription(page?.simplified_chinese_description);
      setEnglishDescription(page?.english_description);
      setTraditionalChineseDescripton(page?.traditional_chinese_description);
      if (page?.bahasa_display_title) {
        let value = page.bahasa_display_title.split("-");
        if (value && value.length > 1)
          setBahasaTitle(value.slice(0, value.length - 1).join("-"));
        else setBahasaTitle(value.join(""));
      } else {
        setBahasaTitle(page.bahasa_display_title || "");
      }
      setBahasaDescription(page?.bahasa_description || "");
      setIsDateEdit(false);
      setFormDate(page?.from_date);
      setToDate(page?.to_date);
      setValidTo(page?.valid_to || page?.to_date || "");
      setValidFrom(page?.valid_from || "");
      // if (page?.selected_type == "promoindexPlans") {
      //   setDisplayAgency([page?.agency?.seawareAgencyCode])
      //   // setAgency(page?.agency?.seawareAgencyCode + "");
      // } else {
      //   setDisplayAgency([page?.agency?.agencyCode])
      //   // setAgency(page?.agency?.agencyCode + "");
      // }
      setVessel(page?.vessel_id + "");

      setAgencyMarketOptions(agencyMargetCodes);

      setAgencyMarketCode(page?.agency_id);
      setMetaDescription(page?.meta_description);
      setMetaKeyWords(page?.meta_keyword);
      setScMetaTitle(page?.sc_meta_keyword);
      setTcMetaTitle(page?.tc_meta_keyword);
      setBahasaMetaTitle(page?.bahasa_meta_keyword);
      setScMetaDescription(page?.sc_meta_description);
      setTcMetaDescription(page?.tc_meta_description);
      setBahasaMetaDescription(page?.bahasa_meta_description);
      setUrl(page?.url);
      setAltText(pickAltText(page, SPECIAL_PAGE_ALT_FIELDS));
      setSlug(
        page.url?.replaceAll(`${constants.PRODUCTION_URL}/special-pages/`, "")
      );
      setIsActive(page?.is_active === 1 ? true : false);
      if (iteneries?.length > 0) setItineraries(iteneries || []);
      setSelectedOption(page?.selected_type);
      return () => clearTimeout(timer);
    }
  }, [page]);

  useEffect(() => {
    if (page && allLocations.length > 0) {
      const pageTz = allLocations.find(l => l.id == page?.location_id)?.timezone || "Asia/Kuala_Lumpur";
      const initialValidFrom = page?.valid_from ? moment.utc(page.valid_from).tz(pageTz).format("YYYY-MM-DDTHH:mm:ss") : "";
      const initialValidTo = page?.valid_to ? moment.utc(page.valid_to).tz(pageTz).format("YYYY-MM-DDTHH:mm:ss") : (page?.to_date || "");
      setValidFrom(initialValidFrom);
      setValidTo(initialValidTo);
      originalValidDates.current = { valid_from: initialValidFrom, valid_to: initialValidTo };
      setIsDateEdit(false);
    }
  }, [page, allLocations]);

  useEffect(() => {
    const agencyIds = displayLocation.map(
      (item) => locationOption.find((l) => l.id === item)?.agency_id
    );
    setAgencyMarketCode(agencyIds);
    const matchedLocations = locationOption.filter((l) =>
      displayLocation.includes(l.id)
    );

    const rawValues =
      cruiseType === "agencyCode"
        ? matchedLocations.map((loc) => loc.agency?.agencyCode)
        : matchedLocations.map((loc) => loc.agency?.seawareAgencyCode);

    const uniqueValues = [...new Set(rawValues.filter(Boolean))];
    setDisplayAgency(uniqueValues);

    const agencyOptionData =
      cruiseType === "agencyCode"
        ? uniqueValues.map((val) => ({ agencyCode: val }))
        : uniqueValues.map((val) => ({ seawareAgencyCode: val }));

    setAgencyOptions(agencyOptionData);

  }, [displayLocation]);

  useEffect(() => {
    getAllLocations().then(data => {
      if (!data?.error) setAllLocations(data?.data || []);
    });
  }, []);

  useEffect(() => {
    if (activeTab === "iti-tab") {
      getData();
    }
  }, [activeTab]);
  const getData = async (value, sort, order) => {
    let args = {
      search: "",
      page: 1,
      limit: 100000,
      id: itineraries,
      agencyId: agencyMarketCode,
      vessel_id: vessel,
      selected_type: selectedOption,
    };

    args.fromDate = from_date;
    args.toDate = to_date;
  };
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleCheckboxChange = () => {
    try {
      if (new Date(valid_to) < new Date()) {
        throw new Error(`Special Page is expired`);
      }
      setIsActive(!isActive);
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e.message,
      });
    }
  };

  const handleDelete = (value) => {
    setDisplayLocation((data) => data.filter((item) => item !== value));
  };
 const handleAgencyDelete = (value) => {
  setDisplayAgency((prev) => {
    const updated = prev.filter((item) => item !== value);
    setAgency(updated.join(", "));
    return updated; 
  });
};
  useEffect(() => {
    if (page?.id && ports?.departure_port?.length > 0) {
      setport(page.display_departure_port || []);
    }
  }, [ports]);
  useEffect(() => {
    if (
      itineraries.length > 0 &&
      agencyMarketCode &&
      vessel &&
      selectedOption
    ) {
      getPorts();
    }
  }, [itineraries, agencyMarketCode, vessel, selectedOption]);
  const getPorts = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = {
      search: "",
      page: 1,
      limit: 100000,
      id: itineraries,
      agencyId: agencyMarketCode.filter((item) => item != null),
      vessel_id: vessel,
      selected_type: selectedOption,
    };
    if (args?.agencyId?.length > 0) {
      let location = await getSpecialPageLocation(args);
      setPorts(location?.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    getOptionLocation();
  }, [cruiseType]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    console.log("cruise_type", cruiseType);
    // let data = await getAgencies();
    // let data = await getSeawareAgencies({ fields: cruiseType });
    let vessels = await getVessels();
    // if (data.error) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: data.error,
    //   });
    // } else {
      // setAgencyOptions(data);
      setVesselOptions(vessels);
    // }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  useEffect(() => { }, [activeTab]);

  // useEffect(() => {
  //   if (!page?.id) {
  //     setLocationOption([]);
  //     setDisplayLocation([]);
  //   }
  // }, [agency]);

  // const getLocationData = async () => {
  //   if (page.image) {
  //     let data = await getLocationSpecialPageData({ image: page?.image });
  //     const seawareAgencyCodesArr = [
  //       ...new Set(data.map(item => item.agency?.seawareAgencyCode).filter(Boolean))
  //     ];
  //     const agencyCodesArr = [
  //       ...new Set(data.map(item => item.agency?.agencyCode).filter(Boolean))
  //     ];

  //     let payload = {};
  //     let options = [];
  //     if (page.selected_type === "promoindexPlans") {
  //       options = seawareAgencyCodesArr;
  //       payload = options.length
  //         ? { seaware_agency_code: options.join(",") }
  //         : {};
  //     } else {
  //       options = agencyCodesArr;
  //       payload = options.length
  //         ? { agency_code: options.join(",") }
  //         : {};
  //     }
  //     setDisplayAgency(options);
  //     let locations = await getLocationByAgency(payload)
  //     // let locations = await getLocationByAgency({
  //     //   agency_code: agency || page?.agency?.agencyCode,
  //     // });

  //     if (data.error) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: data.error,
  //       });
  //     } else {
  //       setLocationOption(locations);
  //       setCurrentLocation(data);
  //       setCurrentLocation(data);
  //       setDisplayLocation(data?.map((item) => item.location_id) || []);
  //     }
  //   }
  // };
    const getLocationData = async () => {
      const pageImage =
        page?.image ||
        page?.simplified_chinese_image ||
        page?.traditional_chinese_image ||
        page?.bahasa_image;
      if (pageImage) {
        let data = await getLocationSpecialPageData({ image: pageImage });
      const seawareAgencyCodesArr = [
        ...new Set(data.map(item => item.agency?.seawareAgencyCode).filter(Boolean))
      ];
      const agencyCodesArr = [
        ...new Set(data.map(item => item.agency?.agencyCode).filter(Boolean))
      ];

      let payload = {};
      let options = [];
      if (page.selected_type === "promoindexPlans") {
        options = seawareAgencyCodesArr;
        payload = options.length
          ? { seaware_agency_code: options.join(",") }
          : {};
      } else {
        options = agencyCodesArr;
        payload = options.length
          ? { agency_code: options.join(",") }
          : {};
      }
      setDisplayAgency(options);
      // let locations = await getLocationByAgency(payload)
      // let locations = await getLocationByAgency({
      //   agency_code: agency || page?.agency?.agencyCode,
      // });

      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        // setLocationOption(locations);
        setCurrentLocation(data);
        setCurrentLocation(data);
        setDisplayLocation(data?.map((item) => item.location_id) || []);
      }
    }
  };
  let getURl = () => {
    let newURL;
    let invalidTitle = [undefined, null];
    if (slug) {
      newURL = slug;
    } else if (!invalidTitle.includes(englishTitle)) {
      newURL = englishTitle.toLocaleLowerCase().replaceAll(" ", "_");
    } else if (
      !englishTitle &&
      !invalidTitle.includes(simplifiedChineseTitle)
    ) {
      newURL = simplifiedChineseTitle.toLocaleLowerCase().replaceAll(" ", "_");
    } else if (
      !englishTitle &&
      !simplifiedChineseTitle &&
      !invalidTitle.includes(traditionalChineseTitle)
    ) {
      newURL = traditionalChineseTitle.toLocaleLowerCase().replaceAll(" ", "_");
    }
    newURL = newURL.toLocaleLowerCase().replaceAll(" ", "_").split("-")[0];
    return `${constants.PRODUCTION_URL}/special-pages/${newURL}`;
  };

  const addPage = async (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let dataValues = {
      image: page?.image,
      traditional_chinese_image: page?.traditional_chinese_image,
      simplified_chinese_image: page?.simplified_chinese_image,
      bahasa_image: page?.bahasa_image,
      english_display_title: englishTitle,
      simple_chinese_display_title: simplifiedChineseTitle,
      traditional_chinese_display_title: traditionalChineseTitle,
      bahasa_display_title: bahasaTitle,
      english_description: englishdescription,
      simplified_chinese_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescripton,
      bahasa_description: bahasaDescription,
      is_active: page?.id ? (isActive ? 1 : 0) : 1,
      from_date: from_date,
      selected_type: selectedOption,
      to_date: to_date,
      valid_from: new Date(valid_from),
      valid_to: new Date(valid_to),
      url: getURl(),
      agency_id: agencyMarketCode.filter((item) => item != null),
      vessel_id: vessel,
      show_home: page?.show_home || 0,
      ...altText,
    };

    try {
      if (selectedFile) {
        if (typeof selectedFile === "string") {
          dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.DEAL_IMG,
            subType: IMAGE_SUB_TYPE.ENGLISH_IMG,
          };
          let image = await uploadData(
            selectedFile,
            imageType,
            typeof page?.image === "string"
              ? page.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
              : null
          );
          if (image?.error) throw new Error(image.error);

          dataValues.image = image?.url;
        }
      } else {
        dataValues.image = "";
      }
      if (traditionalChineseFile) {
        if (typeof traditionalChineseFile === "string") {
          dataValues.traditional_chinese_image = traditionalChineseFile.replace(
            constants.MEDIAURL + "/",
            ""
          );
        } else {
          let imageType = {
            type: IMAGE_TYPE.DEAL_IMG,
            subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
          };
          let image = await uploadData(
            traditionalChineseFile,
            imageType,
            typeof page?.traditional_chinese_image === "string"
              ? page.traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
              : null
          );
          if (image?.error) throw new Error(image.error);

          dataValues.traditional_chinese_image = image?.url;
        }
      } else {
        dataValues.traditional_chinese_image = "";
      }
      if (simplifiedChineseFile) {
        if (typeof simplifiedChineseFile === "string") {
          dataValues.simplified_chinese_image = simplifiedChineseFile.replace(
            constants.MEDIAURL + "/",
            ""
          );
        } else {
          let imageType = {
            type: IMAGE_TYPE.DEAL_IMG,
            subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
          };
          let image = await uploadData(
            simplifiedChineseFile,
            undefined,
            typeof page?.simplified_chinese_image === "string"
              ? page.simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
              : null
          );
          if (image?.error) throw new Error(image.error);

          dataValues.simplified_chinese_image = image?.url;
        }
      } else {
        dataValues.simplified_chinese_image = "";
      }
      if (bahasaFile) {
        if (typeof bahasaFile === "string") {
          dataValues.bahasa_image = bahasaFile.replace(
            constants.MEDIAURL + "/",
            ""
          );
        } else {
          let imageType = {
            type: IMAGE_TYPE.DEAL_IMG,
            subType: IMAGE_SUB_TYPE.BAHASA_IMG,
          };
          let image = await uploadData(
            bahasaFile,
            imageType,
            typeof page?.bahasa_image === "string"
              ? page.bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
              : null
          );
          if (image?.error) throw new Error(image.error);

          dataValues.bahasa_image = image?.url;
        }
      } else {
        dataValues.bahasa_image = "";
      }

      let requiredFields = [];
      if (itineraries?.length < 1 || !itineraries) {
        throw new Error("Add Fare Code");
      }

      if (
        !dataValues.image &&
        !dataValues.traditional_chinese_image &&
        !dataValues.simplified_chinese_image &&
        !dataValues.bahasa_image
      ) {
        throw new Error("please upload the image");
      }

      let valid = checkFields(dataValues, "deals", requiredFields);
      dataValues.meta_description = metaDescription;
      dataValues.meta_keyword = metaKeyWords;
      dataValues.sc_meta_keyword = scMetaTitle;
      dataValues.tc_meta_keyword = tcMetaTitle;
      dataValues.bahasa_meta_keyword = bahasaMetaTitle;
      dataValues.sc_meta_description = scMetaDescription;
      dataValues.tc_meta_description = tcMetaDescription;
      dataValues.bahasa_meta_description = bahasaMetaDescription;
      if (valid) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: valid,
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } else {
        try {
          let args = {
            limit: 10,
            page: 1,
            search: "",
            id: itineraries,
            agencyId: agencyMarketCode.filter((item) => item != null),
            vessel_id: vessel,
            selected_type: selectedOption,
            itinearyId: "",
            fromDate: from_date,
            toDate: to_date,
            cruiseType
          };
          await getSpecialPagePackages(args);
          setError();
          let locationData = displayLocation.map((item, index) => {
            let locationValue = currentLocation.find(
              (data) => data.location_id === item
            );

            let loc = locationOption.find((val) => val.id === item);
            let values = {
              id: locationValue?.id,
              location_id: item,
              ...dataValues,
              valid_from: moment.tz(valid_from, loc?.timezone || "Asia/Kuala_Lumpur").utc().format("YYYY-MM-DDTHH:mm:ss"),
              valid_to: moment.tz(valid_to, loc?.timezone || "Asia/Kuala_Lumpur").utc().format("YYYY-MM-DDTHH:mm:ss"),
            };

            const searchLocationByAgency = locationOption.find(
              (l) => l.id === item
            );

            let args = {
              search: "",
              page: 1,
              limit: 100000,
              id: itineraries,
              agencyId: agencyMarketCode.filter((item) => item != null),
              vessel_id: vessel,
              selected_type: selectedOption,
              cruiseType
            };

            args.fromDate = from_date;
            args.toDate = to_date;

            values = {
              ...values,

              agency_id: searchLocationByAgency.agency_id,
              english_display_title: values.english_display_title
                ? `${values.english_display_title}-${searchLocationByAgency?.agency?.marketCode}`
                : values.english_display_title,
              simple_chinese_display_title: values.simple_chinese_display_title
                ? `${values.simple_chinese_display_title}-${searchLocationByAgency?.agency?.marketCode}`
                : values.simple_chinese_display_title,
              traditional_chinese_display_title:
                values.traditional_chinese_display_title
                  ? `${values.traditional_chinese_display_title}-${searchLocationByAgency?.agency?.marketCode}`
                  : values.traditional_chinese_display_title,
              bahasa_display_title:
                values.bahasa_display_title
                  ? `${values.bahasa_display_title}-${searchLocationByAgency?.agency?.marketCode}`
                  : values.bahasa_display_title,
              url: !includecode
                ? values.url
                : `${values.url}-${searchLocationByAgency?.agency?.marketCode}`,
              departure_port: ports?.departure_port,
              simplified_departure_port: ports?.simplified_departure_port,
              traditional_departure_port: ports?.traditional_departure_port,
              destinations: ports?.destinations,
              sailing_date: ports?.sailing_date,
              simplified_destinations: ports?.simplified_destinations,
              traditional_destinations: ports?.traditional_destinations,
              bahasa_departure_port: ports?.bahasa_departure_port,
              bahasa_destinations: ports?.bahasa_destinations,
              display_departure_port: port,
              recordIteration: index + 1,
              display_simplified_departure_port: port.map(
                (item) =>
                  ports?.simplified_departure_port?.[
                  ports?.departure_port?.findIndex((val) => val == item) ?? -1
                  ] || 0
              ),
              display_traditional_departure_port: port.map(
                (item) =>
                  ports?.traditional_departure_port?.[
                  ports?.departure_port?.findIndex((val) => val == item) ?? -1
                  ] || 0
              ),
              display_bahasa_departure_port: port.map(
                (item) =>
                  ports?.bahasa_departure_port?.[
                  ports?.departure_port?.findIndex((val) => val == item) ?? -1
                  ] || 0
              ),
            };
            return values;
          });
         
          // Compute, from the whole group's current state, which old image
          // files this save will orphan — an old value held by any location
          // in the group that won't match the new value being applied
          // everywhere. Sent once to the backend after the save below
          // finishes, so it doesn't depend on request ordering.
          const SPECIAL_PAGE_IMAGE_FIELDS = ["image", "simplified_chinese_image", "traditional_chinese_image", "arabic_image", "bahasa_image"];
          const oldImageValues = new Set();
          currentLocation.forEach((item) => {
            SPECIAL_PAGE_IMAGE_FIELDS.forEach((field) => {
              if (item[field]) oldImageValues.add(item[field]);
            });
          });
          const imagesToDelete = Array.from(oldImageValues).filter(
            (file) => !SPECIAL_PAGE_IMAGE_FIELDS.some((field) => dataValues[field] === file)
          );

          await Promise.all(
            currentLocation.map(async (item) => {
              if (!displayLocation.includes(item.location_id)) {
                await deleteSpecialPagesData(item.id);
              }
            })
          );
          let finalValue = {
            locationData,
            fare_codes: itineraries,
            fare_args: args,
            isDateEdit,
          };

          let specialPage = await createSpecialPages(finalValue);
          if (specialPage?.data?.length > 0) {
            await cleanupSpecialPageImages(imagesToDelete);
            if (page?.id) {
              addlog(
                "Special Pages Updated",
                "Special_Pages",
                {
                  id: page.id,
                  title:
                    dataValues.english_display_title ||
                    page.english_display_title,
                  url: url || page.url,
                },
                userDetails.id
              );
            } else {
              addlog(
                "Special Pages Created",
                "Special_Pages",
                {
                  id: specialPage?.data?.[0]?.id,
                  title: dataValues.english_display_title,
                  url: dataValues.url,
                },
                userDetails.id
              );
            }
            navigate("/website/cms/special-pages");
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: specialPage.error || "Unknown error occurred",
            });
          }
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
          // await Promise.all(
          //   currentLocation.map(async (item) => {
          //     if (!displayLocation.includes(item.location_id)) {
          //       await deleteSpecialPagesData(item.id);
          //     }
          //   })
          // );

          // await Promise.all(
          //   displayLocation.map(async (item, index) => {
          //     let loc = locationOption.find((val) => val.id === item);

          //     let values = {
          //       location_id: item,
          //       ...dataValues,
          //       valid_from: moment(getTimeData(valid_from, loc.timezone))
          //         .utc()
          //         .format("YYYY-MM-DDTHH:mm:ss"),
          //       valid_to: moment(getTimeData(valid_to, loc.timezone))
          //         .utc()
          //         .format("YYYY-MM-DDTHH:mm:ss"),
          //     };
          //     if (!isDateEdit) {
          //       delete values?.valid_from;
          //       delete values?.valid_to;
          //     }
          //     const searchLocationByAgency = locationOption.find(
          //       (l) => l.id === item
          //     );

          //     let args = {
          //       search: "",
          //       page: 1,
          //       limit: 100000,
          //       id: itineraries,
          //       agencyId: agencyMarketCode,
          //       vessel_id: vessel,
          //       selected_type: selectedOption,
          //     };

          //     args.fromDate = from_date;
          //     args.toDate = to_date;

          //     values = {
          //       ...values,

          //       agency_id: searchLocationByAgency.agency_id,
          //       english_display_title: values.english_display_title
          //         ? `${values.english_display_title}-${searchLocationByAgency?.agency?.marketCode}`
          //         : values.english_display_title,
          //       simple_chinese_display_title:
          //         values.simple_chinese_display_title
          //           ? `${values.simple_chinese_display_title}-${searchLocationByAgency?.agency?.marketCode}`
          //           : values.simple_chinese_display_title,
          //       traditional_chinese_display_title:
          //         values.traditional_chinese_display_title
          //           ? `${values.traditional_chinese_display_title}-${searchLocationByAgency?.agency?.marketCode}`
          //           : values.traditional_chinese_display_title,
          //       url: !includecode
          //         ? values.url
          //         : `${values.url}-${searchLocationByAgency?.agency?.marketCode}`,
          //       departure_port: ports?.departure_port,
          //       simplified_departure_port: ports?.simplified_departure_port,
          //       traditional_departure_port: ports?.traditional_departure_port,
          //       destinations: ports?.destinations,
          //       sailing_date: ports?.sailing_date,
          //       simplified_destinations: ports?.simplified_destinations,
          //       traditional_destinations: ports?.traditional_destinations,
          //       display_departure_port: port,
          //       display_simplified_departure_port: port.map(
          //         (item) =>
          //           ports?.simplified_departure_port[
          //             ports.departure_port.findIndex((val) => val == item)
          //           ] || 0
          //       ),
          //       display_traditional_departure_port: port.map(
          //         (item) =>
          //           ports?.traditional_departure_port[
          //             ports.departure_port.findIndex((val) => val == item)
          //           ] || 0
          //       ),
          //     };
          //     let specialPage;
          //     let res;

          //     if (page?.id) {
          //       let locationValue = currentLocation.filter(
          //         (data) => data.location_id === item
          //       );
          //       if (locationValue.length > 0) {
          //         let { ...rest } = values;
          //         if (item === page.location_id) {
          //           specialPage = await updateSpecialPagesData(
          //             locationValue[0].id,
          //             values
          //           );
          //         } else {
          //           specialPage = await updateSpecialPagesData(
          //             locationValue[0].id,
          //             rest
          //           );
          //         }
          //       } else {
          //         specialPage = await createSpecialPages({
          //           ...values,
          //           recordIteration: index + 1,
          //         });
          //       }
          //     } else
          //       specialPage = await createSpecialPages({
          //         ...values,
          //         recordIteration: index + 1,
          //       });
          //     if (specialPage?.error) {
          //       throw new Error(specialPage.error);
          //     }
          //     let data;

          //     if (specialPage?.id) {
          //       data = await createSpecialPagesPackage({
          //         special_page_id: specialPage?.id,
          //         fare_codes: itineraries,
          //       });
          //     }
          //     if (page?.id) {
          //       addlog(
          //         "Special Pages Updated",
          //         "Special_Pages",
          //         {
          //           id: page.id,
          //           title:
          //             dataValues.english_display_title ||
          //             page.english_display_title,
          //           url: url || page.url,
          //         },
          //         userDetails.id
          //       );
          //     } else {
          //       addlog(
          //         "Special Pages Created",
          //         "Special_Pages",
          //         {
          //           id: data.id,
          //           title: dataValues.english_display_title,
          //           url: dataValues.url,
          //         },
          //         userDetails.id
          //       );
          //     }
          //     if (!page?.id) {
          //       navigate("/website/cms/special-pages");
          //     } else {
          //       navigate("/website/cms/special-pages");
          //       dispatch({
          //         type: "SET_ERROR_MESSAGE",
          //         errMess: { message: "Values updated", type: "success" },
          //       });
          //     }
          //   })
          // );
        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.message || "Unknown error occurred",
          });
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
          // setError(error.message);
        }
      }
    } catch (error) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });
    }
  };

  const validatePage = () => {
    const valid = checkFields({
      agency,
      market_code: agencyMarketCode,
      cruise_name: vessel,
    });
    if (valid) {
      setActiveTab("page-setup");
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    }
    return valid;
  };

  const handleLocationChange = () => {
    console.log("test",displayLocation)
    if (!selectAll) {
      setDisplayAgency(locations.map((item) => item.id));
    } else {
      setDisplayLocation([]);
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxLocationChange = () => {
    if (!selectAll) {
      setDisplayLocation(locationOption.map((item) => item.id));
    } else {
      setDisplayLocation([]);
    }
    setSelectAll(!selectAll);
  };
  const handleCheckboxAgencyChange = () => {
    if (!selectAllAgencies) {
      const key =
        cruiseType === "agencyCode"
          ? "agencyCode"
          : cruiseType === "seawareAgencyCode"
            ? "seawareAgencyCode"
            : null;

      if (key) {
        const allValues = agencyOptions.map((item) => item[key]);
        setDisplayAgency(allValues);
        setAgency(allValues.join(","));
      }
    } else {
      setDisplayAgency([]);
      setAgency("")
    }
    setSelectAllAgencies(!selectAllAgencies);
  };
  const handleCruiseTypeChange = async (e) => {
    const value = e.target.value;
    setCruiseTypeOptions(value);
    setItineraries([])
    setAgency("");
    setDisplayAgency([]);
    setAgencyOptions([]);
    setDisplayLocation([]);
    setSelectAll(false);
    if (value === "seawareAgencyCode") {
      setSelectedOption("promoindexPlans");
    } else {
      setSelectedOption("");
    } 
    // setDisplayAgency([]);
    // setAgency("")
    // setDisplayAgency([]);
  };

  const handleAgencyChange = async (e) => {
    setAgency(e.join(", "));
    try {
    } catch (err) {
      setLocationOption([]);
    } finally {
      dispatch({ type: "SET_LOADING", loading: false });
    }
  };

  const handleLoctionChange = async (e) => {
    try {
      console.log("location-->",e)
      // setLocationOption(e)
    } catch (err) {
      setLocationOption([]);
    } 
  }
  // useEffect(() => {
  //   if (agency) {
  //     getAgenecyData();
  //   }
  // }, [agency]);
  useEffect(() => {
    if (cruiseType)
      getAllLocationData()
      // getcruiseTypeData()
  }, [cruiseType])
  const getAgenecyData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    const payload =
      cruiseType === "agencyCode"
        ? { agency_code: agency }
        : cruiseType === "seawareAgencyCode"
          ? { seaware_agency_code: agency }
          : {};
    const locations = await getLocationByAgency(payload);
    setLocationOption(locations || []);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
   const getAllLocationData= async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    const locations = await getAllLocation();
    console.log("locations",locations)
    setLocationOption(locations || []);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const getcruiseTypeData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    const agencyData = await getSeawareAgencies({ fields: cruiseType });
    setAgencyOptions(agencyData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  return (
    <div>
      <div style={{ marginLeft: "10px" }}>
        <SwitchBar
          tabs={[
            { title: "Page Setup", value: "page-setup" },
            { value: "iti-tab", title: " Itineraries" },
            { value: "iti-seo", title: "SEO" },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <section className="content">
        {/* {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )} */}

        {activeTab === "page-setup" && (
          <div className="container-fluid">
            <div className="card">
              <form className="input_form" onSubmit={addPage}>
                <div className="card-body">
                  <div className="row">
                    {/* <LocationAndExpcept
                      displayLocation={displayLocation}
                      banner={page}
                      locationOption={locationOption}
                      options={locationOption}
                      setDisplayLocation={setDisplayLocation}
                      handleDisplayLocationChange={handleDisplayLocationChange}
                    /> */}

                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          English Display Title{" "}
                          {!englishTitle &&
                            !simplifiedChineseTitle &&
                            !traditionalChineseTitle && (
                              <span style={{ color: "red" }}> *</span>
                            )}
                        </label>
                        <input
                          // required
                          className="f_input"
                          type="text"
                          value={englishTitle}
                          onChange={(e) => {
                            if (e.target.value.length < 44) {
                              setEnglishTitle(e.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Simplified Chinese Display Title
                        </label>
                        <input
                          // required
                          className="f_input"
                          type="text"
                          value={simplifiedChineseTitle}
                          onChange={(e) => {
                            if (e.target.value.length < 44)
                              setSimplifiedChineseTitle(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Traditional Chinese Display Title
                        </label>
                        <input
                          // required
                          className="f_input"
                          type="text"
                          value={traditionalChineseTitle}
                          onChange={(e) => {
                            if (e.target.value.length < 44)
                              setTraditionalChineseTitle(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">Bahasa Display Title</label>
                        <input
                          className="f_input"
                          type="text"
                          value={bahasaTitle}
                          onChange={(e) => {
                            if (e.target.value.length < 44)
                              setBahasaTitle(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Cruise Type <span style={{ color: "red" }}> *</span>
                        </label>
                        <Select
                          required
                          style={{ width: "100%", height: "45px" }}
                          value={cruiseType}
                          onChange={handleCruiseTypeChange}
                        >
                          {cruiseTypeOptions.map((item, index) => (
                            <MenuItem key={index + ""} value={item.fields}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Display Location{" "}
                          <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <SelectInputs
                          modules={"special_page"}
                          locationType="DisplayLocation"
                          selectedValue={displayLocation}
                          // disabled={banner.id}
                          options={locationOption}
                          setSelectedValue={(e) => {
                            setDisplayLocation(e);
                          }}
                          style={{ width: "100%", height: "45px" }}
                          value={displayLocation}
                          // onChange={(e) => handleLoctionChange(e)}
                        />
                        <div className="iti_inner">
                          <div className="icheck-primary d-inline">
                            <input
                              type="checkbox"
                              id="customCheckbox6"
                              name="r10"
                              checked={selectAll}
                              onChange={handleCheckboxLocationChange}
                            />
                            <label htmlFor="customCheckbox6">
                              {selectAll ? (
                                <p>
                                  <span style={{ fontWeight: 600 }}>
                                    Remove All
                                  </span>
                                </p>
                              ) : (
                                <p>
                                  <span style={{ fontWeight: 200 }}>
                                    Select All
                                  </span>
                                </p>
                              )}
                            </label>
                          </div>
                        </div>
                        {displayLocation?.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",

                              maxHeight: "100px",
                              border: "1px solid black",
                              padding: "10px",
                              overflowY: "scroll",
                              borderRadius: "6px",
                            }}
                          >
                            {displayLocation.map((data, index) => (
                              <Chip
                                onDelete={() => handleDelete(data)}
                                key={index + ""}
                                size="small"
                                sx={{
                                  borderRadius: "100px",
                                }}
                                label={
                                  locationOption?.find(
                                    (item) => item.id === data
                                  )?.location_name
                                }
                              ></Chip>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
               
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Cruise Name <span style={{ color: "red" }}> *</span>
                        </label>
                        <Select
                          required
                          style={{ width: "100%", height: "45px" }}
                          value={vessel}
                          onChange={(e) => setVessel(e.target.value)}
                        >
                          {vesselOptions.map((item, index) => (
                            <MenuItem key={index + ""} value={item?.id}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>

                      <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Agency{" "}
                          <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <SelectInputs1
                          modules={"special_page"}
                          locationType="DisplayAgency"
                          cruiseType={cruiseType}
                          selectedValue={displayAgency}
                          // disabled={banner.id}
                          options={agencyOptions}
                          setSelectedValue={(e) => {
                            setDisplayAgency(e);
                            setAgency(e.join(",")); 
                          }}
                          style={{ width: "100%", height: "45px" }}
                          value={displayAgency}
                          onChange={(e) => handleAgencyChange(e)}
                        />
                        {/* <div className="iti_inner">
                          <div className="icheck-primary d-inline">
                            <input
                              type="checkbox"
                              id="customCheckbox7"
                              name="r10"
                              checked={selectAllAgencies}
                              onChange={(e) => handleCheckboxAgencyChange(e)}
                            />
                            <label htmlFor="customCheckbox7">
                              {selectAllAgencies ? (
                                <p>
                                  <span style={{ fontWeight: 600 }}>
                                    Remove All
                                  </span>
                                </p>
                              ) : (
                                <p>
                                  <span style={{ fontWeight: 200 }}>
                                    Select All
                                  </span>
                                </p>
                              )}
                            </label>
                          </div>
                        </div>
                        {displayAgency?.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "5px",

                              maxHeight: "100px",
                              border: "1px solid black",
                              padding: "10px",
                              overflowY: "scroll",
                              borderRadius: "6px",
                            }}
                          >
                            {displayAgency.map((data, index) => (
                              <Chip
                                onDelete={() => handleAgencyDelete(data)}
                                key={index + ""}
                                size="small"
                                sx={{
                                  borderRadius: "100px",
                                }}
                                label={data}
                              ></Chip>
                            ))} 
                           </div>
                        )}  */}
                      </div>
                    </div>


                    {/* <div className="col-lg-4"></div> */}

                    <UploadFileImageBanner2
                      className="col-lg-3"
                      width={778}
                      mediaType={"image"}
                      height={542}
                      image={
                        page?.image
                          ? `${constants.MEDIAURL}/${page?.image}`
                          : page?.image
                      }
                      label={"English Page Image"}
                      placeholder={"Upload English Page Image"}
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                    />
                    <UploadFileImageBanner2
                      mediaType={"image"}
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        page?.simplified_chinese_image
                          ? `${constants.MEDIAURL}/${page?.simplified_chinese_image}`
                          : page?.simplified_chinese_image
                      }
                      label={"Simplified Chinese Page Image"}
                      placeholder={"Upload Simplified Chinese Page Image "}
                      selectedFile={simplifiedChineseFile}
                      setSelectedFile={setSimplifiedChineseFile}
                    />
                    <UploadFileImageBanner2
                      mediaType={"image"}
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        page?.traditional_chinese_image
                          ? `${constants.MEDIAURL}/${page?.traditional_chinese_image}`
                          : page?.traditional_chinese_image
                      }
                      label={"Traditional Chinese Page Image "}
                      placeholder={"Upload Traditional Chinese Page Image "}
                      selectedFile={traditionalChineseFile}
                      setSelectedFile={setTraditionalChineseFile}
                    />
                    <UploadFileImageBanner2
                      mediaType={"image"}
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        page?.bahasa_image
                          ? `${constants.MEDIAURL}/${page?.bahasa_image}`
                          : page?.bahasa_image
                      }
                      label={"Bahasa Page Image"}
                      placeholder={"Upload Bahasa Page Image"}
                      selectedFile={bahasaFile}
                      setSelectedFile={setBahasaFile}
                    />
                    <AltTextInput className="col-lg-3" label="English Page Image Alt Text" field="image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Simplified Chinese Page Image Alt Text" field="simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Traditional Chinese Page Image Alt Text" field="traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Bahasa Page Image Alt Text" field="bahasa_image_alt" values={altText} setValues={setAltText} />

                    <div className="col-3">
                      <div className="fieldrow">
                        <label className="f_label">English Description</label>
                        <ReactQuill
                          value={englishdescription}
                          onChange={(e) => {
                            setEnglishDescription(e);
                          }}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="fieldrow">
                        <label className="f_label">
                          Simplified Chinese Description
                        </label>
                        <ReactQuill
                          value={simplifiedChineseDescription}
                          onChange={(e) => setSimplifiedChineseDescription(e)}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="fieldrow">
                        <label className="f_label">
                          Traditional Chinese Description
                        </label>
                        <ReactQuill
                          value={traditionalChineseDescripton}
                          onChange={setTraditionalChineseDescripton}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="fieldrow">
                        <label className="f_label">Bahasa Description</label>
                        <ReactQuill
                          value={bahasaDescription}
                          onChange={setBahasaDescription}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>

                    <div className="row w-100">
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="add_iti">
                          <h4 className="sub_title2">Add Itineraries</h4>
                          <div className="iti_inner">
                            {cruiseType !== "seawareAgencyCode" ? (
                              <>
                                <div className="icheck-primary d-inline">
                                  <input
                                    type="radio"
                                    value="specificRatePlans"
                                    checked={
                                      selectedOption === "specificRatePlans"
                                    }
                                    onChange={handleRadioChange}
                                    id="radioPrimary1"
                                    name="r1"
                                  />
                                  <label htmlFor="radioPrimary1">
                                    Specific Rate Plans
                                  </label>
                                </div>
                                <div className="icheck-primary d-inline">
                                  <input
                                    type="radio"
                                    value="rateplan"
                                    checked={selectedOption === "rateplan"}
                                    onChange={handleRadioChange}
                                    id="radioPrimary2"
                                    name="r1"
                                  />
                                  <label htmlFor="radioPrimary2">
                                    Rate Plan
                                  </label>
                                </div>
                                <div className="icheck-primary d-inline">
                                  <input
                                    type="radio"
                                    value="rateplantype"
                                    checked={selectedOption === "rateplantype"}
                                    onChange={handleRadioChange}
                                    id="radioPrimary3"
                                    name="r1"
                                  />
                                  <label htmlFor="radioPrimary3">
                                    Rate Plan Type
                                  </label>
                                </div>
                                <div className="icheck-primary d-inline">
                                  <input
                                    type="radio"
                                    value="promoindex"
                                    checked={selectedOption === "promoindex"}
                                    onChange={handleRadioChange}
                                    id="radioPrimary4"
                                    name="r1"
                                  />
                                  <label htmlFor="radioPrimary4">
                                    Promo Index
                                  </label>
                                </div>
                              </>
                            ) : cruiseType === "seawareAgencyCode" ? (
                              <div className="icheck-primary d-inline">
                                <input
                                  type="radio"
                                  value="promoindexPlans"
                                  checked={selectedOption === "promoindexPlans"}
                                  onChange={handleRadioChange}
                                  id="radioPrimary5"
                                  name="r1"
                                />
                                <label htmlFor="radioPrimary5">
                                  Promo Name
                                </label>
                              </div>
                            ) : null}
                          </div>
                          <div className="iti_input">
                            <RatePlanInput
                              selectedOption={selectedOption}
                              chips={itineraries}
                              setChips={setItineraries}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="sailing_date">
                          <h4 className="sub_title2">Sailing Date</h4>
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                              <div className="fieldrow">
                                <label className="f_label">
                                  From <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                  required
                                  value={from_date}
                                  onChange={(e) => {
                                    setFormDate(e.target.value);
                                    setValidFrom("");
                                    setToDate("");
                                    setValidTo("");
                                  }}
                                  className="f_input"
                                  type="date"
                                  min={
                                    page?.created_at
                                      ? moment(
                                        new Date(page?.created_at)
                                      ).format("YYYY-MM-DD")
                                      : moment(new Date()).format("YYYY-MM-DD")
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                              <div className="fieldrow">
                                <label className="f_label">
                                  To <span style={{ color: "red" }}> *</span>
                                </label>
                                <input
                                  required
                                  className="f_input"
                                  value={to_date}
                                  onChange={(e) => {
                                    setToDate(e.target.value);
                                    setValidTo(e.target.value);
                                  }}
                                  type="date"
                                  min={moment(from_date).format("YYYY-MM-DD")}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="fieldrow">
                          <label className="f_label">Page Slug</label>
                          <input
                            className="f_input w-75"
                            value={slug}
                            onChange={(e) => setSlug(e.target.value)}
                            type="text"
                          />
                          <div className="col-12">
                            <div className="iti_inner">
                              <div className="icheck-primary d-inline">
                                <p style={{ fontSize: 14, color: "grey" }}>{`${constants.PRODUCTION_URL
                                  }/special-pages/${slug
                                    ?.toLocaleLowerCase()
                                    .replaceAll(" ", "_")
                                    .split("-")?.[0]
                                  }${includecode ? "-(market code)" : ""}`}</p>
                                <input
                                  type="checkbox"
                                  id="customCheckboxmarkt"
                                  name="r10"
                                  disabled={slug.includes("-")}
                                  checked={includecode}
                                  onChange={(e) =>
                                    setIncludeCode(e.target.checked)
                                  }
                                />
                                <label htmlFor="customCheckboxmarkt">
                                  {includecode ? (
                                    <p>
                                      <span style={{ fontWeight: 600 }}>
                                        Include Market Code
                                      </span>
                                    </p>
                                  ) : (
                                    <p>
                                      <span style={{ fontWeight: 200 }}>
                                        Include Market Code
                                      </span>
                                    </p>
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                          <div className="sailing_date">
                            <h4 className="sub_title2">Valid Date</h4>

                            <div className="row">
                              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div className="fieldrow">
                                  <label className="f_label">
                                    From{" "}
                                    <span style={{ color: "red" }}> *</span>
                                  </label>

                                  <DateAndTimePicker
                                    max={moment(to_date || new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                    disabled={!(from_date && to_date)}
                                    min={
                                      page?.created_at
                                        ? moment(
                                          new Date(page.created_at)
                                        ).format("YYYY-MM-DD")
                                        : moment(new Date()).format(
                                          "YYYY-MM-DD"
                                        )
                                    }
                                    value={valid_from}
                                    setValue={(e) => {
                                      const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                                      setValidFrom(val);
                                      setValidTo("");
                                      setIsDateEdit(
                                        val !== originalValidDates.current.valid_from ||
                                        "" !== originalValidDates.current.valid_to
                                      );
                                      if (
                                        moment(val).format("YYYY-MM-DD") >
                                        moment(new Date()).format("YYYY-MM-DD")
                                      ) {
                                        setIsActive(false);
                                      }
                                      if (
                                        moment(val).format("YYYY-MM-DD") <=
                                        moment(new Date()).format("YYYY-MM-DD")
                                      ) {
                                        setIsActive(true);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div className="fieldrow">
                                  <label className="f_label">
                                    To <span style={{ color: "red" }}> *</span>
                                  </label>

                                  <DateAndTimePicker
                                    max={moment(to_date).format("YYYY-MM-DD")}
                                    min={moment(valid_from).format(
                                      "YYYY-MM-DD"
                                    )}
                                    value={valid_to}
                                    disabled={!valid_from}
                                    setValue={(e) => {
                                      const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                                      setValidTo(val);
                                      setIsDateEdit(
                                        valid_from !== originalValidDates.current.valid_from ||
                                        val !== originalValidDates.current.valid_to
                                      );

                                      if (
                                        moment(val).format("YYYY-MM-DD") <
                                        moment(new Date()).format("YYYY-MM-DD")
                                      ) {
                                        setIsActive(false);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {ports?.departure_port && (
                        <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                          <div className="fieldrow">
                            <label className="f_label">Port Name</label>
                            <PortInputs
                              modules={"special_page"}
                              locationType="DisplayLocation"
                              selectedValue={port}
                              // disabled={banner.id}
                              options={ports?.departure_port}
                              setSelectedValue={(e) => {
                                setport(e);
                              }}
                              style={{ width: "100%", height: "45px" }}
                              value={port}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12"></div>
                    <div className="col-12">
                      <div className="iti_inner">
                        <div className="icheck-primary d-inline">
                          <input
                            type="checkbox"
                            id="customCheckbox4"
                            name="r10"
                            checked={isActive}
                            onChange={handleCheckboxChange}
                          />
                          <label htmlFor="customCheckbox4">
                            {isActive ? (
                              <p>
                                <span style={{ fontWeight: 600 }}>Active</span>
                              </p>
                            ) : (
                              <p>
                                <span style={{ fontWeight: 200 }}>Active</span>
                              </p>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-right">
                  <button className="btn main_submit">
                    {page?.id ? "Update" : "Add"} Special Page
                  </button>
                </div>
              </form>
            </div>
            <div className="pt-3"></div>
          </div>
        )}
        {activeTab === "iti-tab" && !validatePage() && (
          <div className="container-fluid">
            <div className="card">
              <FareCodeList
                locationOption={locationOption}
                displayLocation={displayLocation}
                itineraries={itineraries}
                from_date={from_date}
                to_date={to_date}
                valid_from={valid_from}
                valid_to={valid_to}
                activeTab={activeTab}
                agency={agencyMarketCode}
                selectedOption={selectedOption}
                vessel={vessel}
                cruiseType={cruiseType}
              />
            </div>
          </div>
        )}
        {activeTab === "iti-seo" && (
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={metaKeyWords}
                        onChange={(e) => setMetaKeyWords(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={scMetaTitle}
                        onChange={(e) => setScMetaTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={tcMetaTitle}
                        onChange={(e) => setTcMetaTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Meta Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={bahasaMetaTitle}
                        onChange={(e) => setBahasaMetaTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Meta Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={metaDescription}
                        onChange={(e) => setMetaDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Meta Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={scMetaDescription}
                        onChange={(e) => setScMetaDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Traditional Chinese Meta Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={tcMetaDescription}
                        onChange={(e) => setTcMetaDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Meta Description</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={bahasaMetaDescription}
                        onChange={(e) => setBahasaMetaDescription(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};
SpecialPagesInputs.propTypes = {
  page: PropTypes.any,
  iteneries: PropTypes.any,
  agencyMargetCodes: PropTypes.any,
};
export default SpecialPagesInputs;
